import { render } from "./cwzb.vue?vue&type=template&id=df608cc6&scoped=true&ts=true"
import script from "./cwzb.vue?vue&type=script&lang=ts"
export * from "./cwzb.vue?vue&type=script&lang=ts"

import "./cwzb.vue?vue&type=style&index=0&id=df608cc6&lang=less&scoped=true"

import exportComponent from "D:\\客户端h5\\operationmanual\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-df608cc6"]])

export default __exports__